// Shared native haptic feedback (Capacitor Haptics plugin).
//
// Lives in ui-shared so EVERY surface can feel tactile on iOS/Android with one
// import: the shared Button, the arcade games, and the lesson/book answer
// outcomes — not just the mobile-native screens (which have their own copy in
// mobile/src/native.ts). No-op on web and whenever the plugin is unavailable, so
// it is always safe to call unconditionally.

interface HapticsPlugin {
  impact?: (opts: { style: string }) => Promise<void>;
  notification?: (opts: { type: string }) => Promise<void>;
}

function hapticsPlugin(): HapticsPlugin | undefined {
  if (typeof window === 'undefined') return undefined;
  const cap = (window as unknown as {
    Capacitor?: { isNativePlatform?: () => boolean; Plugins?: { Haptics?: HapticsPlugin } };
  }).Capacitor;
  if (!cap?.isNativePlatform?.()) return undefined; // native shells only
  return cap.Plugins?.Haptics;
}

/** Light tap — button presses, tile selects, navigation. Fire-and-forget. */
export function tapHaptic(style: 'LIGHT' | 'MEDIUM' | 'HEAVY' = 'LIGHT'): void {
  try { void hapticsPlugin()?.impact?.({ style }); } catch { /* best-effort */ }
}

/** Outcome buzz — correct/wrong answers, saves, level-ups. Fire-and-forget. */
export function notifyHaptic(type: 'SUCCESS' | 'WARNING' | 'ERROR' = 'SUCCESS'): void {
  try { void hapticsPlugin()?.notification?.({ type }); } catch { /* best-effort */ }
}
